<script setup lang="ts">
import { IconProps } from './IconProps';

withDefaults(defineProps<IconProps>(), {
  width: 16,
  height: 16,
  viewBox: '0 0 16 16',
  background: 'none',
  color: '#788EAE',
  opacity: 1,
});
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :fill="background"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 11C15 11.5304 14.7893 12.0391 14.4142 12.4142C14.0391 12.7893 13.5304 13 13 13H3C2.46957 13 1.96086 12.7893 1.58579 12.4142C1.21071 12.0391 1 11.5304 1 11V5C1 4.46957 1.21071 3.96086 1.58579 3.58579C1.96086 3.21071 2.46957 3 3 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5V11ZM7.25 7.5C7.25 7.36739 7.19732 7.24021 7.10355 7.14645C7.00979 7.05268 6.88261 7 6.75 7H3C2.86739 7 2.74021 7.05268 2.64645 7.14645C2.55268 7.24021 2.5 7.36739 2.5 7.5V8C2.5 8.13261 2.55268 8.25979 2.64645 8.35355C2.74021 8.44732 2.86739 8.5 3 8.5H6.75C6.88261 8.5 7.00979 8.44732 7.10355 8.35355C7.19732 8.25979 7.25 8.13261 7.25 8V7.5ZM8.75 10.5C8.75 10.3674 8.80268 10.2402 8.89645 10.1464C8.99021 10.0527 9.11739 10 9.25 10H13C13.1326 10 13.2598 10.0527 13.3536 10.1464C13.4473 10.2402 13.5 10.3674 13.5 10.5V11C13.5 11.1326 13.4473 11.2598 13.3536 11.3536C13.2598 11.4473 13.1326 11.5 13 11.5H9.25C9.11739 11.5 8.99021 11.4473 8.89645 11.3536C8.80268 11.2598 8.75 11.1326 8.75 11V10.5ZM13.5 8V7.5C13.5 7.36739 13.4473 7.24021 13.3536 7.14645C13.2598 7.05268 13.1326 7 13 7H9.25C9.11739 7 8.99021 7.05268 8.89645 7.14645C8.80268 7.24021 8.75 7.36739 8.75 7.5V8C8.75 8.13261 8.80268 8.25979 8.89645 8.35355C8.99021 8.44732 9.11739 8.5 9.25 8.5H13C13.1326 8.5 13.2598 8.44732 13.3536 8.35355C13.4473 8.25979 13.5 8.13261 13.5 8ZM6.75 11.5C6.88261 11.5 7.00979 11.4473 7.10355 11.3536C7.19732 11.2598 7.25 11.1326 7.25 11V10.5C7.25 10.3674 7.19732 10.2402 7.10355 10.1464C7.00979 10.0527 6.88261 10 6.75 10H3C2.86739 10 2.74021 10.0527 2.64645 10.1464C2.55268 10.2402 2.5 10.3674 2.5 10.5V11C2.5 11.1326 2.55268 11.2598 2.64645 11.3536C2.74021 11.4473 2.86739 11.5 3 11.5H6.75Z"
      :fill="color"
    />
  </svg>
</template>
